import { planCrop } from "./cropPlan";

export interface CropOptions {
  /** 결과 긴 변 상한(px). 넘으면 같은 비율로 축소 — 확대는 없음 */
  maxSide?: number;
  /** JPEG 품질 (0–1). 기본 0.92 */
  quality?: number;
}

/**
 * 이미지 data URL을 지정 비율로 중앙 크롭(+ 긴 변 상한 축소)해 새 data URL로 반환.
 * 포맷/품질은 입력이 JPEG면 JPEG(0.92), 그 외엔 PNG.
 * 잘라낼 것도 줄일 것도 없으면 입력을 그대로 돌려준다 — 불필요한 재인코딩(2세대 JPEG 손실)을 피한다.
 */
export async function cropDataUrlToAspect(
  dataUrl: string,
  aspect: { w: number; h: number },
  { maxSide, quality = 0.92 }: CropOptions = {}
): Promise<string> {
  const img = await loadImage(dataUrl);
  const srcW = img.naturalWidth;
  const srcH = img.naturalHeight;
  if (!srcW || !srcH) return dataUrl;

  const plan = planCrop(srcW, srcH, aspect, maxSide);
  if (plan.identity) return dataUrl;

  const canvas = document.createElement("canvas");
  canvas.width = plan.dw;
  canvas.height = plan.dh;
  const ctx = canvas.getContext("2d");
  if (!ctx) return dataUrl;
  ctx.drawImage(img, plan.sx, plan.sy, plan.sw, plan.sh, 0, 0, plan.dw, plan.dh);

  const isJpeg = dataUrl.startsWith("data:image/jpeg");
  return isJpeg
    ? canvas.toDataURL("image/jpeg", quality)
    : canvas.toDataURL("image/png");
}

export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("이미지 로드 실패"));
    img.src = src;
  });
}
